export default __webpack_public_path__ + "static/media/example.8d720d23.png";